/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleUserVm
 */
export interface SimpleUserVm {
    /**
     * 
     * @type {string}
     * @memberof SimpleUserVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleUserVm
     */
    name?: string | null;
}

export function SimpleUserVmFromJSON(json: any): SimpleUserVm {
    return SimpleUserVmFromJSONTyped(json, false);
}

export function SimpleUserVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleUserVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SimpleUserVmToJSON(value?: SimpleUserVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


